import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import ViewDocumentor from '@/components/disposable/ViewDocumentor.vue';
import { DocumentType } from '@/model/document';

export default /*#__PURE__*/_defineComponent({
  __name: 'OnlyfansActorView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ViewDocumentor, {
    "document-type": _unref(DocumentType).Onlyfans,
    "ref-name": 'actor'
  }, null, 8, ["document-type"]))
}
}

})